module.exports = __webpack_public_path__ + "static/img/2_02.197b35a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/junActivitySpecialty2/2_02.png
// module id = JtV4
// module chunks = 0